import { Locale } from '@ps-smart-cp/ppfw-client';

const applyCategoryConfig = {
  laContractLedger: new Map([[Locale.ja, '契約台帳']]),
  laArticleLedger: new Map([[Locale.ja, '物件台帳']]),
};

export { applyCategoryConfig };
